/*
  Free-shipping bar — live updater.

  The bar is rendered server-side, but this store adds to cart through several
  paths (theme product form, PageFly, apps) that don't all re-render the drawer.
  This script keeps the bar in sync by recomputing it from the real cart total
  on ANY cart change: theme pub/sub events + intercepted fetch/XHR to /cart/*.
*/
(function () {
  'use strict';

  var DEFAULT_GOAL = 7999000; // cents ($79.990) — fallback if data-goal missing

  var TRUCK =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3 6.5A1.5 1.5 0 0 1 4.5 5H14a1 1 0 0 1 1 1v9H4.5A1.5 1.5 0 0 1 3 13.5v-7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
    '<path d="M15 9h3.2a1 1 0 0 1 .82.43l1.8 2.57a1 1 0 0 1 .18.57V15H15V9Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
    '<circle cx="7" cy="17.5" r="1.8" stroke="currentColor" stroke-width="1.8"/>' +
    '<circle cx="17.5" cy="17.5" r="1.8" stroke="currentColor" stroke-width="1.8"/></svg>';

  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Mismo formato que el filtro money de la tienda ($7,499): miles con coma.
  function formatCLP(cents) {
    var pesos = Math.round(cents / 100);
    return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function update(total) {
    var bar = document.querySelector('.free-shipping-bar');
    if (!bar) return;

    var goal = parseInt(bar.getAttribute('data-goal'), 10) || DEFAULT_GOAL;
    var pct = goal > 0 ? Math.min(100, Math.floor((total * 100) / goal)) : 0;
    var complete = total >= goal;

    bar.classList.toggle('free-shipping-bar--complete', complete);

    var fill = bar.querySelector('.free-shipping-bar__fill');
    if (fill) fill.style.transform = 'scaleX(' + pct / 100 + ')';

    var icon = bar.querySelector('.free-shipping-bar__icon');
    if (icon) icon.innerHTML = complete ? CHECK : TRUCK;

    var text = bar.querySelector('.free-shipping-bar__text');
    if (text) {
      text.innerHTML = complete
        ? 'Tienes <span class="free-shipping-bar__amount">envío gratis</span> en este pedido'
        : 'Te faltan <span class="free-shipping-bar__amount">' +
          formatCLP(goal - total) +
          '</span> para el envío gratis';
    }
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { update(cart.total_price); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  // 1) Theme pub/sub (fires on standard theme add/update)
  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 50); });
  }

  // 2) Intercept fetch to /cart/* (covers apps / custom add-to-cart)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var p = origFetch.apply(this, arguments);
      if (isCartWrite(url)) p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      return p;
    };
  }

  // 3) Intercept XMLHttpRequest to /cart/* (covers older apps)
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fsbCartWrite = isCartWrite(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__fsbCartWrite) {
        this.addEventListener('load', function () { setTimeout(refresh, 60); });
      }
      return origSend.apply(this, arguments);
    };
  }

  // 4) Initial sync once the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
